

// Bot List

export const botList = "/bots"


// Delete .
export const delete_Bot = '/bots'


//Group list

export const  groupList = "/group/get_my_groups"

export const update_group_Token_Allocation = "/group/update_tokens"

// Group token Usages.
export const groupToken = "/getTokenUsed_by_group_id"

// Plan Feature Details .
export const planFeature = "/plan_features"


// Group Details .
export const groupDetails = "/group/group_info"


// Bot Details

export const botDetails = "/bots"

// Get List of all tools .
export const get_tool_list = "/tool_master_list"


// Update tool status of a bot .
export const update_tool_status = "/tool_activation_deactivation"

// Models
export const models = "/model"

// Models
export const embedding_models = "/embedding_models_list"

// Update Bot Configurations .
export const update_Bot_Configurations = "/updateChatGPTS"

// Update Bot Configurations with logo .
export const update_Bot_Configurations_logo = "/bots"

export const update_Bot_title = "/update_bot_title"


// Get Bot Categories
export const bot_Catgory = "/bot_category"

// Get all distinct bot categories.
export const all_categories_distinct = "/bot_category"


// Get Bot threads.
export const bot_Threads = "/chat_threads"

// Clear context .
export const clear_context = "/ClearContext"



// delete single thread
export const thread_delete = "/chat_threads" 

//delete thread bulk.
export const delete_thread_bulk = "/delete_thread_bulk"

// CReate New Thread
export const new_thread = "/chat_threads"

// Edit thread .
export const edit_thread_title = "/chat_threads"


//Response Stream
export const chat_reponse = "/bots/stream"


//Event Stream
export const event_stream = "/bots/node_execution_event_stream"


//Thumb up message .
export const thumb_up_message = "/bots/update_feedback_user_chat_logs"

// Get Group User Logs . 
export const group_user_logs = "/bots/get_user_bot_chat_logs"


// Custom Chat .
export const chat_history = "/get_threads_message";
// Delete Chat message .
export const delete_chat_message = "/ChatHistory";
// Custom Chat .
export const chat_history_mongo = "/ChatHistory";


// Ask Bot .
export const ask_bot = "/chat_stream"

// Ask Bot .
export const ask_bot_database = "/chat_stream_with_database"

//Create New Bot
export const create_new_bot = "/" 

// favourite Prompt List
export const fav_prompt_list = "/get_Bot_Favorite_Prompt" 

//favourite Prompt Category list
export const fav_prompt_category = "/get_Bot_Fav_Prmpt_Category_by_Group" 
export const delete_fav_prompt_category = "/set_fav_prompt_category_on_deletion" 

// Get Bot user. 
export const get_bot_user = "/bots/user"


// Token Used Previous Month , Group and Bot Wise .
export const getTokenUsedMonthwise = "/token_usage"


// cancel Bot Response Stream .
export const cancel_response_stream = "/bots/stop_response_completion"



// Create Combine Bot .
export const create_combine_bot = "/creat_chatbot_starting"
// Create Combine Bot .
export const create_combine_bot_logo = "/bots"

// Ask question for Fav Prompt.
export const fav_prompt_question_Generation = "/bots/get_fav_prompt_question"

// User in group .


// Update Favorite bot.
export const update_favorite_prompt = "/update_Bot_Favorite_Prompt"


// Update knowlege base for combine bot.
export const update_combine_bot = "/bots/Edit_SaveBot_with_Combine_text_file_qa"

// Save Fav Prompt
export const save_fav_prompt = "/save_Bot_Favorite_Prompt"

// Delete Fav Prompt.
export const delete_fav_prompt = "/delete_prompt"
// Delete Group .
export const delete_group = "/delete_group"

//Add New DB .
export const add_new_db_connection = "/db_connections"

// Get Sample Database list .
export const get_sample_db_list = "/SampleDB"

// Insert Sample Db list.
export const Insert_sample_Db = "/db_connections/insert_sample_database_into_dbconnection"

// Edit DB Connections . 
export const edit_db_connection = "/db_connections"

// //Add New DB .
// export const add_new_db_connection_logo = "/create_DB_Connection"

// Get DB Connection List . 
export const get_DB_connections= "/db_connections"

//Execute Mongo Query .
export const mongo_query_executor = "/db_connections/execute_mongo_query"

// Create DB bot.
 export const create_db_bot = "/create_database_structure"


 // Create DB bot.
 export const create_db_bot_logo = "/create_database_structure_with_logo"




 // Get Table list by id .
 export const get_table_list = "/db_table"

 // Table Count .
 export const fetch_table_count = "/table_count"

 // Add user to Bot .
 export const add_user_to_bot = "/bots/user/add"


 //Update DB bot API .
 export const update_DB_bot = "/db_table/EditSave_Bot_with_DatabaseStructure"



 // Delete Bot user By Id .
 export const delete_bot_user = "/bots/user/delete"

 // Create New Group .
 export const create_new_group = "/group"
 // Update Group Info.
 export const update_group_info = "/group"

 // Get group USer info .
 export const group_user_details =  '/user_group/get_group_users_info'
 


// Fetch Wesite links.
export const Fetch_Website_Links = "/crawler"
export const Fetch_Web_site_map = "/crawler"



// Get All User .
export const get_all_users = "/search_user"

// Get Group User By Bot Id
export const get_group_user_by_bot_id = "/get_group_users_bybotid"


// Get SQL Data .
export const get_sql_data = "/db_connections/execute_given_sql"



// Update Group User .
export const update_group_user = "/user_group/add_or_update_user_to_group_invitation"



// Leave Group By Group id
export const leave_group_group_id ="/leave_group_by_group_id"


// Ask question with file .
export const ask_bot_with_file = "/bots/chat_stream_with_files"

// Ask question with file and data base .
export const ask_bot_with_file_database = "/bots/chat_stream_with_database_and_files"



// Pans.
export const fetch_plans = "/plan"
//plans summary
export const plans_summary = "/PaymentDetails/get_payment_summary"
//Get Billing Information.
export const get_billings = "/PaymentDetails/get_billings"
// Fetch payment methods
export const payment_methods = "/PaymentDetails/get_subscription_details"
// Add payment methods
export const add_payment_methods = "/payment/add_new_payment_method"
// Purchase Add on.
export const purchase_addon = "/payment"
// Get current plan add on details .
export const get_current_plan_add_on = "/get_add_on_details_current"

// Start plan checkout .
export const plan_check_out = "/payment"



//REGISTER
export const POST_REGISTER = "/signup";

//LOGIN
export const POST_LOGIN = "/login";
export const login = "/login";

// Verify Confirm Password Mail link. 
export const reset_email_password ="/verify_reset_password_email"

export const reset_email_send ="/forget_password"

export const update_password = "/user"

// Update user image .
export const update_user_image = "/user"

// Update bot image .
export const update_bot_image= "/update_bot_image"


// Get User Details .
export const get_user_details = "/user"

// Update user details . 
export const update_user_details = "/user"


// Text to speech .
export const text_to_speech = "/synthesize"

// Speech to Text .
export const speech_to_text = "/SpeechSynthesize/speech_to_text"



export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";

// Calendar
export const GET_EVENTS = "/events";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMMINGEVENT = "/upcommingevents";
export const ADD_NEW_EVENT = "/add/event";
export const UPDATE_EVENT = "/update/event";
export const DELETE_EVENT = "/delete/event";

// Chat
export const GET_DIRECT_CONTACT = "/chat";
export const GET_MESSAGES = "/get_threads_message";
export const ADD_MESSAGE = "add/message";
export const GET_CHANNELS = "/channels";
export const DELETE_MESSAGE = "delete/message";

//Mailbox
export const GET_MAIL_DETAILS = "/mail";
export const DELETE_MAIL = "/delete/mail";

// Ecommerce
// Product
export const GET_PRODUCTS = "/apps/product";
export const DELETE_PRODUCT = "/apps/product";
export const ADD_NEW_PRODUCT = "/apps/product";
export const UPDATE_PRODUCT = "/apps/product";

// Orders
export const GET_ORDERS = "/apps/order";
export const ADD_NEW_ORDER = "/apps/order";
export const UPDATE_ORDER = "/apps/order";
export const DELETE_ORDER = "/apps/order";

// Customers
export const GET_CUSTOMERS = "/apps/customer";
export const ADD_NEW_CUSTOMER = "/apps/customer";
export const UPDATE_CUSTOMER = "/apps/customer";
export const DELETE_CUSTOMER = "/apps/customer";

// Sellers
export const GET_SELLERS = "/sellers";

// Project list
export const GET_PROJECT_LIST = "/project/list";

// Task
export const GET_TASK_LIST = "/apps/task";
export const ADD_NEW_TASK = "/apps/task";
export const UPDATE_TASK = "/apps/task";
export const DELETE_TASK = "/apps/task";

// CRM
// Conatct
export const GET_CONTACTS = "/apps/contact";
export const ADD_NEW_CONTACT = "/apps/contact";
export const UPDATE_CONTACT = "/apps/contact";
export const DELETE_CONTACT = "/apps/contact";

// Companies
export const GET_COMPANIES = "/apps/company";
export const ADD_NEW_COMPANIES = "/apps/company";
export const UPDATE_COMPANIES = "/apps/company";
export const DELETE_COMPANIES = "/apps/company";

// Lead
export const GET_LEADS = "/apps/lead";
export const ADD_NEW_LEAD = "/apps/lead";
export const UPDATE_LEAD = "/apps/lead";
export const DELETE_LEAD = "/apps/lead";

// Deals
export const GET_DEALS = "/deals";

// Crypto
export const GET_TRANSACTION_LIST = "/transaction-list";
export const GET_ORDRER_LIST = "/order-list";

// Invoice
export const GET_INVOICES = "/apps/invoice";
export const ADD_NEW_INVOICE = "/apps/invoice";
export const UPDATE_INVOICE = "/apps/invoice";
export const DELETE_INVOICE = "/apps/invoice";

// TicketsList
export const GET_TICKETS_LIST = "/apps/ticket";
export const ADD_NEW_TICKET = "/apps/ticket";
export const UPDATE_TICKET = "/apps/ticket";
export const DELETE_TICKET = "/apps/ticket";

// Dashboard Analytics

// Sessions by Countries
export const GET_ALL_DATA = "/all-data";
export const GET_HALFYEARLY_DATA = "/halfyearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

// Audiences Metrics
export const GET_ALLAUDIENCESMETRICS_DATA = "/allAudiencesMetrics-data";
export const GET_MONTHLYAUDIENCESMETRICS_DATA = "/monthlyAudiencesMetrics-data";
export const GET_HALFYEARLYAUDIENCESMETRICS_DATA = "/halfyearlyAudiencesMetrics-data";
export const GET_YEARLYAUDIENCESMETRICS_DATA = "/yearlyAudiencesMetrics-data";

// Users by Device
export const GET_TODAYDEVICE_DATA = "/todayDevice-data";
export const GET_LASTWEEKDEVICE_DATA = "/lastWeekDevice-data";
export const GET_LASTMONTHDEVICE_DATA = "/lastMonthDevice-data";
export const GET_CURRENTYEARDEVICE_DATA = "/currentYearDevice-data";

// Audiences Sessions by Country
export const GET_TODAYSESSION_DATA = "/todaySession-data";
export const GET_LASTWEEKSESSION_DATA = "/lastWeekSession-data";
export const GET_LASTMONTHSESSION_DATA = "/lastMonthSession-data";
export const GET_CURRENTYEARSESSION_DATA = "/currentYearSession-data";

// Dashboard CRM

// Balance Overview
export const GET_TODAYBALANCE_DATA = "/todayBalance-data";
export const GET_LASTWEEKBALANCE_DATA = "/lastWeekBalance-data";
export const GET_LASTMONTHBALANCE_DATA = "/lastMonthBalance-data";
export const GET_CURRENTYEARBALANCE_DATA = "/currentYearBalance-data";

// Deal type
export const GET_TODAYDEAL_DATA = "/todayDeal-data";
export const GET_WEEKLYDEAL_DATA = "/weeklyDeal-data";
export const GET_MONTHLYDEAL_DATA = "/monthlyDeal-data";
export const GET_YEARLYDEAL_DATA = "/yearlyDeal-data";

// Sales Forecast

export const GET_OCTSALES_DATA = "/octSales-data";
export const GET_NOVSALES_DATA = "/novSales-data";
export const GET_DECSALES_DATA = "/decSales-data";
export const GET_JANSALES_DATA = "/janSales-data";

// Dashboard Ecommerce
// Revenue
export const GET_ALLREVENUE_DATA = "/allRevenue-data";
export const GET_MONTHREVENUE_DATA = "/monthRevenue-data";
export const GET_HALFYEARREVENUE_DATA = "/halfYearRevenue-data";
export const GET_YEARREVENUE_DATA = "/yearRevenue-data";

// Dashboard Crypto
// Portfolio
export const GET_BTCPORTFOLIO_DATA = "/btcPortfolio-data";
export const GET_USDPORTFOLIO_DATA = "/usdPortfolio-data";
export const GET_EUROPORTFOLIO_DATA = "/euroPortfolio-data";

// Market Graph
export const GET_ALLMARKETDATA_DATA = "/allMarket-data";
export const GET_YEARMARKET_DATA = "/yearMarket-data";
export const GET_MONTHMARKET_DATA = "/monthMarket-data";
export const GET_WEEKMARKET_DATA = "/weekMarket-data";
export const GET_HOURMARKET_DATA = "/hourMarket-data";

// Dashboard Crypto
// Project Overview
export const GET_ALLPROJECT_DATA = "/allProject-data";
export const GET_MONTHPROJECT_DATA = "/monthProject-data";
export const GET_HALFYEARPROJECT_DATA = "/halfYearProject-data";
export const GET_YEARPROJECT_DATA = "/yearProject-data";

// Project Status
export const GET_ALLPROJECTSTATUS_DATA = "/allProjectStatus-data";
export const GET_WEEKPROJECTSTATUS_DATA = "/weekProjectStatus-data";
export const GET_MONTHPROJECTSTATUS_DATA = "/monthProjectStatus-data";
export const GET_QUARTERPROJECTSTATUS_DATA = "/quarterProjectStatus-data";

// Dashboard NFT
// Marketplace
export const GET_ALLMARKETPLACE_DATA = "/allMarketplace-data";
export const GET_MONTHMARKETPLACE_DATA = "/monthMarketplace-data";
export const GET_HALFYEARMARKETPLACE_DATA = "/halfYearMarketplace-data";
export const GET_YEARMARKETPLACE_DATA = "/yearMarketplace-data";

// Project
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

// Pages > Team
export const GET_TEAMDATA = "/teamData";
export const DELETE_TEAMDATA = "/delete/teamData";
export const ADD_NEW_TEAMDATA = "/add/teamData";
export const UPDATE_TEAMDATA = "/update/teamData";

// File Manager
// Folder
export const GET_FOLDERS = "/folder";
export const DELETE_FOLDER = "/delete/folder";
export const ADD_NEW_FOLDER = "/add/folder";
export const UPDATE_FOLDER = "/update/folder";

// File
export const GET_FILES = "/file";
export const DELETE_FILE = "/delete/file";
export const ADD_NEW_FILE = "/add/file";
export const UPDATE_FILE = "/update/file";

// To do
export const GET_TODOS = "/todo";
export const DELETE_TODO = "/delete/todo";
export const ADD_NEW_TODO = "/add/todo";
export const UPDATE_TODO = "/update/todo";

// To do Project
export const GET_PROJECTS = "/projects";
export const ADD_NEW_TODO_PROJECT = "/add/project";

//JOB APPLICATION
export const GET_APPLICATION_LIST = "/application-list";

//JOB APPLICATION
export const GET_API_KEY = "/api-key";

// kanban
export const GET_TASKS = "/apps/tasks";
export const ADD_TASKS = "/add/tasks";
export const UPDATE_TASKS = "/update/tasks";
export const DELETE_TASKS = "/delete/tasks";



// Workflow node .
export const workflow_node = "/workflow_node"



// Workflow node .
export const workflow_list = "/workflow"


// Dash board list .
export const dashboard_list = "/get_group_dashboards"

// Get list of bot based of bot_id.
export const dasboard_bot_list = "/group/get_group_bot_list"

// Fav prompt list .
export const fav_prompt_list_by_group = "/group_dashboard/bot_favorite_prompt_sql"

// Get Chaert options

export const get_chart_options = "/group_dashboard/get_xaxis_yaxis_values"


// Dash board list .
export const delete_dashboard= "/delete_dashboard"



// Dash board list .
export const create_dashboard = "/create_new_group_dashboard"

// Get element data . 
export const fetch_dashboard_element_data = "/group_dashboard/create_sql_graph"

// Save DashBoard .
export const save_dashboard_elements = "/dashboard_graph_master/create_dashboard_element"

// get Dashboard category list .

export const get_dashboard_category = "/group_dashboard/get_distinct_dashboard_category"

// Get Dashboard Data .
export const get_dashboard_data = "/dashboard_graph_master/get_dashboard_elements"

// Create Work Floe . 
export const create_workflow = "/workflow_builder"

// Get Work Flow Category .
 export const get_workflow_category_list = "/workflow/get_distinct_workflow_category"


// DELETE Work Flow Category .
 export const delete_workflow = "/delete_workflow"


 // Save Share point Credentials .

 export const share_point_creds = "/sharepoint/GetSharepointDirectoryList"

  export const share_point_directory_list = "/sharepoint/GetSharepointSubDirectoryList"


export const knowledge_upload_status = "/bots/streaming_notifications/"


export const update_dashboard_details = "/update_group_dashboard"


export const insert_into_db_table = "/bots/generate_insertion_query"

